<template>
  <div class="video_wrap">
    <IframeVideo :url="videoURL" />

    <img v-if="demoImg" :src="demoImg" alt="">

    <div class="bottom">
      <div class="position">
        <div class="title">
          <span>预设点位</span>
          <span>
          </span>
          <van-button type="primary" @click="putPoint">编辑</van-button>
        </div>
        <div class="nums">
          <div :class="['item' ,  item.active && 'active' , !item.inUse && 'noUse' ]" v-for="(item,index) in preset" :key="item.label" @click="postPoint(item , index)">{{ item.label }}</div>
        </div>
      </div>
      <div class="contrl">
        <div class="left">
          <div class="circular circular1">
            <div class="circular circular2">
              <!-- 圆点 -->
              <div class="circular circular3"></div>
              <!-- 四个角 -->
              <a id="horn-top" class="horn horn-top" @mousedown="handleMousedown(0)" @mouseup="mouseup(0)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a id="horn-right" class="horn horn-right" @mousedown="handleMousedown(3)" @mouseup="mouseup(3)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a id="horn-bottom" class="horn horn-bottom" @mousedown="handleMousedown(1)" @mouseup="mouseup(1)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a id="horn-left" class="horn horn-left" @mousedown="handleMousedown(2)" @mouseup="mouseup(2)">
                <i class="iconfont icon-xiangxia" />
              </a>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="r_top">
            <div class="box" @click="handleCapture">
              <div class="r_block">
                <img src="./../../../assets/images/shibie.jpg" alt="" />
                <!-- <i
                  class="saoma iconfont icon-icon--"
                  style="font-size: 32px"
                ></i> -->
                <!-- <i class="miaozhun iconfont icon-xialingyingicon-16"></i> -->
              </div>
              <div class="label">识别</div>
            </div>
            <div class="box" @click="handleCtrlClick(10)">
              <div class="r_block">
                <img src="./../../../assets/images/miaozhun.jpg" alt="" />
                <!-- <i
                  class="saoma iconfont icon-icon--"
                  style="font-size: 32px"
                ></i>
                <i class="miaozhun iconfont icon-xialingyingicon-16"></i> -->
              </div>
              <div class="label">对焦</div>
            </div>
          </div>
          <div class="r_bottom">
            <div class="box" @click="handleCtrlClick(8)">
              <div class="r_block">
                <i class="iconfont icon-jia" style="font-size: 22px"></i>
              </div>
              <div class="label">放大</div>
            </div>
            <div class="box" @click="handleCtrlClick(9)">
              <div class="r_block">
                <i class="iconfont icon-jian" style="font-size: 22px"></i>
              </div>
              <div class="label">放小</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 数据 -->
      <div class="flex-col data-page space-y-16">
        <div class="flex-col section space-y-10">
          <div class="flex-row justify-between items-center">
            <div class="flex-row items-center space-x-13">
              <img class="shrink-0 image" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16970039022831963734.png" />
              <span class="text">数据</span>
            </div>
            <span class="font_1 text_2">基础单位：毫米</span>
          </div>
          <div class="flex-col">
            <div class="flex-row justify-between section_2">
              <div class="flex-col justify-start items-center text-wrapper"><span class="font_2">面积</span></div>
              <div class="flex-col justify-start items-center text-wrapper"><span class="font_2">长度</span></div>
              <div class="flex-col justify-start"><span class="font_2">平均直径</span></div>
              <div class="flex-col justify-start items-center text-wrapper"><span class="font_2">体积</span></div>
            </div>
            <div class="flex-row justify-between items-center group">
              <div class="flex-col justify-start items-start text-wrapper_2"><span class="font_3 text_3">131.75</span></div>
              <span class="font_3 text_4">155</span>
              <div class="section_3"></div>
              <span class="font_3 text_5">0.85</span>
              <div class="section_3"></div>
              <span class="font_3 text_6">87.9</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮组 -->
      <div class="btn-group">
        <van-button type="primary" @click="handleSetting(1)">设置</van-button>
        <van-button type="primary" @click="handleSetting(2)">局部数据</van-button>
        <van-button type="primary" @click="handleSetting(3)">详细数据</van-button>
        <van-button type="primary" :disabled="true">上传</van-button>
      </div>

      <!-- <div class="calendar">
        <div class="left">
          <div :class="['date-item', currentDateIndex === index && 'active']" v-for="(item, index) in dates" :key="item.date" @click="handleClickDate(item, index)">
            <div class="week">{{ item.week }}</div>
            <div class="num">{{ item.num }}</div>
          </div>
        </div>
        <div class="right" @click="show = true">
          <i class="iconfont icon-rili" style="font-size: 38px"> </i>
          <span> {{ today.num }}</span>
        </div>
      </div> -->

      <div class="img-group">
        <div v-for="(item, index) in list" :key="index + 1000">
          <!-- <div class="date">{{ item.date }}</div> -->
          <div class="time">
            {{ item.date }} {{ item.week && `周${item.week}` }}
          </div>
          <div class="pic">
            <div v-if="pic" class="pic_item" v-for="(pic, _index) in item.picList" :key="_index">
              <!--  -->
              <ImageProxy :url="pic.thumbUrl" :index="index" :_index="_index" :click="handleClickImg" />
              <div class="time">{{ pic.cdate }}</div>
            </div>
            <div v-else class="pic_item"></div>
          </div>
        </div>
      </div>
    </div>

    <van-calendar v-model="show" @confirm="onConfirm" :max-date="maxDate" :min-date="minDate" />

    <van-popup v-model="pointShow" position="bottom" :style="{ padding: '18px 12px', boxSizing: 'border-box'}">
      <div class="point_popup">
        <div class="title">
          <span>预设点位</span>
          <span>
            <img src="./../../../assets/images/close.png" alt="" srcset="" @click="pointShow = false">
          </span>
        </div>
        <div class="content">
          <div class="nums">
            <div :class="['item', pointDialogActiveIndex === item.index && 'active' ]" v-for="(item,index) in preset" :key="item.label" @click="pointDialogClick(item , index)">{{ item.label }}</div>
          </div>
        </div>
        <div class="btns">
          <div class="btn save" @click="handleSave">保存</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import IframeVideo from "./../components/iframe.vue";
import moment from "moment";
import ScreenShot from "@/utils/screenShot"
import { error } from 'weixin-js-sdk';

let timer = null

export default {
  components: {
    IframeVideo,
  },

  props: {
    videoInfo: {
      type: Object,
      default: () => ({})
    },
    hasDeviceChange: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    online: {
      default: false,
      type: Boolean
    }
  },

  watch: {
    online (v) {
    },

    async hasDeviceChange (v) {
      if (v) {
        const no = localStorage.getItem("no");
        this.no = no;
        this.initPoint([1, 2, 3, 4, 5, 6, 7, 8])
        await this.getThirdCamera()
        this.screenShot = new ScreenShot("iframe")
        await this.getPoint()
      }
    },

    refreshing (bl) {
      bl && this.onRefresh?.();
    }
  },

  data () {
    return {
      dates: [],
      currentDateIndex: null,
      today: {},
      show: false,
      minDate: new Date("1970/1/1"),
      maxDate: new Date(),
      videoURL: "",
      channelNo: "",
      ysNo: "",
      isFirst: true,
      page: 1,
      pageSize: 20,
      oldList: [],
      totalPages: 1,
      list: [],
      finished: true,
      demoImg: "",
      no: localStorage.getItem("no"),
      screenShot: null,
      activePresetPoint: null,
      preset: [1, 2, 3, 4, 5, 6, 7, 8],
      pointShow: false,
      pointDialogActiveIndex: null,
      addLoading: false,
      isMouseUp: false,
      index: 0,
    };
  },

  created () {
    this.initPoint(this.preset)
  },

  async mounted () {

    await this.getThirdCamera()
    this.screenShot = new ScreenShot("iframe")
    await this.getPoint()

    const top = this.$el.querySelector('#horn-top');
    const bottom = this.$el.querySelector('#horn-bottom');
    const right = this.$el.querySelector('#horn-right');
    const left = this.$el.querySelector('#horn-left');
    [top, bottom, left, right].map((dom, index) => {
      dom.addEventListener("touchend", () => {
        clearInterval(timer)
        timer = null
        this.isMouseUp = true
      })
      dom.addEventListener("touchstart", () => {
        clearInterval(timer)
        this.isMouseUp = false

        this.handleCtrlClick(index)


        timer = setInterval(() => {
          if (this.isMouseUp || !timer) return clearInterval(timer)
          this.handleCtrlClick(index)
        }, 300);

      })
    })



  },

  methods: {
    initPoint (preset) {
      this.preset = preset.map(o => {
        return {
          label: `位置${o}`,
          name: o,
          index: o,
          inUse: false,
          active: false
        }
      })
    },

    // 获取预置点
    async getPoint () {
      await this.$api.rootMonitor_getPoint({
        ysNo: this.ysNo,
        channelNo: this.channelNo
      }).then(res => {
        const { errcode } = res
        if (errcode === 0) {
          let preset = res.preset?.length ? res.preset : []
          if (!preset.length) return
          preset.map((o, index) => {
            const findIndex = this.preset.findIndex(io => io.name == o.presetName)
            if (findIndex > -1) {
              this.preset[findIndex].inUse = true
            }
          })
        }
      })
    },

    // 新增预置点
    async putPoint () {
      this.pointShow = true
    },

    // 保存
    async handleSave () {
      if (this.addLoading) return

      this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 0, })
      this.addLoading = true
      console.log(" this.pointDialogActiveIndex:", this.pointDialogActiveIndex);
      const status = await this.addPoint()
      if (status) {
        this.pointShow = false
        this.preset.map(o => {
          if (o.name == this.pointDialogActiveIndex) {
            o.active = true
          } else {
            o.active = false
          }
        })
        // 重新获取
        this.getPoint()
      }
      this.addLoading = false
    },

    async addPoint () {
      // 要判断是新增还是修改
      return await this.$api.rootMonitor_putPoint({
        ysNo: this.ysNo,
        channelNo: this.channelNo,
        "presetName": this.pointDialogActiveIndex,
      }).then(async res => {
        await this.$toast.clear()
        const { errcode, index } = res
        if (errcode === 0) {
          return true
        } else {
          this.$toast(`保存预置点异常:${res.errmsg}`)
          return false
        }
      })
    },

    // 点击调用预置点
    async postPoint (data, index) {
      if (!data.inUse) {
        return this.$toast({ message: "该位置还未设置" })
      }

      this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 0, })
      await this.$api.rootMonitor_postPoint({
        ysNo: this.ysNo,
        channelNo: this.channelNo,
        index: data.index
      }).then(async res => {
        await this.$toast.clear()
        const { errcode, } = res
        if (errcode === 0) {
          this.preset.map(o => (o.active = false))
          setTimeout(() => {
            this.preset[index].active = true
          }, 0);
        } else {
          this.$toast(`调用预置点异常:${res.errmsg}`)
        }
      })
    },

    pointDialogClick (data, index) {
      this.pointDialogActiveIndex = data.index
    },

    // 清除预置点
    async deletePoint (index) {
      await this.$api.rootMonitor_deletePoint({
        "ysNo": this.ysNo,
        "channelNo": this.channelNo,
        index
      })
    },

    // 获取第三方摄像头
    async getThirdCamera (no = this.no) {
      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });

      await this.$api
        .getThirdCamera({ gatewayNo: no })
        .then(res => {
          try {
            this.$toast.clear();
            let token = res.accessToken;

            if (!this.$isblank(res.videos)) {
              const videos = res.videos.map(item => {
                return {
                  ...item,
                  videoHdUrl: `https://open.ys7.com/ezopen/h5/iframe?url=${item.videoHdUrl || item.videoUrl}&accessToken=${token}`
                };
              });
              console.log("videos:", videos);
              return this.renderVideo(videos?.[0] || {})
            } else {
            }
          } catch (err) {
            console.error("err222:", err);
          }
        })
        .catch(err => {
          this.$refs.pageToast && (this.$refs.pageToast.type = 1);
          this.$toast.clear();
        });
    },

    async renderVideo (data) {
      console.log("1111111:", data);
      try {
        let { videoHdUrl, channelNo, ysNo } = data
        this.videoURL = videoHdUrl;


        this.channelNo = channelNo;
        this.ysNo = ysNo;
        // 计算7天时间
        await this.sevenDays(new Date());
        this.currentDateIndex = this.dates.length - 1;
        this.today = this.formatCalendarDay(new Date(), 0);
        this.getPicture();
      } catch (e) {
        console.error("e:", e);
      }
    },


    // 日历 确认
    onConfirm (date) {
      this.sevenDays(date);
      this.currentDateIndex = this.dates.length - 1;
      this.show = false;
      this.getPicture()
    },

    // 切换日期
    handleClickDate (date, index) {
      this.currentDateIndex = index;
      // 请求视频和图片
      this.page = 1
      this.getPicture()
    },

    mouseup (index) {
    },

    handleMousedown (index) {
      let timer = null
      try {
        // document.addEventListener("touchend", () => {
        //   clearInterval(timer)
        //   this.$toast(`监听到抬起${timer}`)
        //   timer = null
        //   this.isMouseUp = true
        // })
        // document.addEventListener("touchstart", () => {
        //   this.$toast("监听到点击")
        //   this.isMouseUp = false

        //   this.isMouseUp = false
        //   // this.handleCtrlClick(index)
        //   timer = setInterval(() => {
        //     console.log("1111:", this.isMouseUp, timer);
        //     this.index = this.index + 1
        //     if (this.isMouseUp || !timer) {
        //       clearInterval(timer)
        //       // return
        //       // this.handleCtrlClick(index == 0 ? 1 : index == 1 ? 0 : index == 2 ? 3 : 2)
        //     }
        //     // this.handleCtrlClick(index == 0 ? 1 : index == 1 ? 0 : index == 2 ? 3 : 2)
        //   }, 0);

        // })


      } catch (err) {
        console.error("errrr: ", err);
      }
    },

    // 视频控制
    async handleCtrlClick (index) {
      if (typeof index !== "number") return;
      await this.$api
        .ctrlCamera({
          ysNo: this.ysNo,
          channelNo: Number(this.channelNo),
          direction: String(index),
        })
        .then((res) => {
          if (res.errcode === 0) {
          } else {
            this.$toast.fail(res.errmsg);
          }
        });
    },

    // 获取摄像头下的图片列表
    async getPicture () {
      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      try {
        this.isFirst = false;
        const { page, pageSize } = this;
        const res = await this.$api.getCameraPicture({
          gatewayNo: localStorage.getItem("no"),
          page,
          pageSize: 5000,
          leDate: this.dates[this.currentDateIndex].date
        });
        this.$toast.clear();

        const list = [...res.list];
        console.log("list:", res.list);
        if (list && list.length) {
          let timeGroup = new Set();
          const newList = [...list];

          // 合在一起后再进行日期分组
          newList.map((item) => {
            if (item.date == null) {
              timeGroup.add(item.cdate.split(" ")[0]);
            } else {
              timeGroup.add(item.date);
            }
          });
          timeGroup = Array.from(timeGroup);
          const newTimeGroup = [];
          timeGroup.map((item) => {
            newTimeGroup.push({
              date: item,
              picList: [],
              week: item ? this.getWeek(item) : "",
            });
          });

          newTimeGroup.map((item) => {
            newList.map((_item) => {
              let date = "";
              if (_item.date == null) {
                date = _item.cdate.split(" ")[0];
              } else {
                date = _item.date;
              }

              if (item.date === date) {
                _item.cdate = _item.cdate ? _item.cdate.split(" ")[1] : "";

                item.picList.push({
                  ..._item,
                });
              }
            });
          });

          newTimeGroup.map((item) => {
            if (item.picList && item.picList.length) {
              const count = 3;
              const m = item.picList.length % count;
              if (m) {
                const l = count - m;
                let arr = {};
                arr.length = l;
                arr = Array.from(arr);
                arr.map(() => {
                  item.picList.push(null);
                });
              }
            }
          });

          this.list = [...newTimeGroup];

          console.log("list:", this.list, this.finished);

          this.totalPages = res.pages;
          this.page++;
        } else {
          this.list = [];
          this.page = 1
        }
      } catch (err) {
        this.$toast.clear();
        console.error(err);
      }
    },

    /**
     * @description 图片点击
     * @param {number} index list中的下标
     * @param {number} _index list中下标对象中的picList中的第几个
     */
    handleClickImg (index, _index) {
      const images = [];
      this.list[index].picList.map((item) => {
        item && images.push(item);
      });

      const { url, cdate, fileId, thumbUrl } = images[_index];

      this.$router.push({
        path: "/ai",
        query: {
          imgUrl: url,
          time: cdate,
          fileId,
        },
      });
    },

    // 截图
    async handleCapture () {

      // const imgBase64 = this.screenShot.shot()
      // console.log("imgBase64:", imgBase64);

      // return

      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      try {
        const res = await this.$api.capture({
          gatewayNo: localStorage.getItem("no"),
          channelNo: this.channelNo,
          quality: 0,
        });

        if (res && res.errcode === 0 && res.picUrl) {
          this.$toast.clear();
          const { picUrl, fileId, } = res
          // this.demoImg = res.picUrl
          this.$router.push({
            path: "/ai",
            query: {
              imgUrl: picUrl,
              time: moment(new Date().getTime()).startOf("s").format("YYYY-MM-DD HH:mm:ss"),
              fileId,
            },
          });
          this.getPicture();
        } else {
          this.$toast.fail((res && res.errmsg) || this.$t("common.service_error"));
          this.demoImg = "";
        }
      } catch (err) {
        this.$toast.fail(this.$t("common.service_error"));
      }
    },

    sevenDays (date) {
      const nowDate = moment(date).startOf("day").format("YYYY-MM-DD"); // 当前时间点
      const dates = [];
      for (let i = 0; i < 6; i++) {
        dates.push(this.formatCalendarDay(nowDate, i + 1));
      }
      dates.reverse();
      dates.push(this.formatCalendarDay(nowDate, 0));

      console.log("dates:", dates);
      this.dates = dates;
    },

    // 参数时间戳
    getWeek (date) {
      let week = moment(date).day();
      switch (week) {
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        case 4:
          return "四";
        case 5:
          return "五";
        case 6:
          return "六";
        case 0:
          return "日";
      }
    },

    formatCalendarDay (date, i) {
      const d = moment(date).subtract(i, "days").format("YYYY-MM-DD");
      return {
        date: d,
        week: this.getWeek(new Date(d.replaceAll("-", "/")).getTime()),
        num: d.split("-")[2],
      };
    },

    handleSetting (type) {
      const path = type == 1 ? "/videoPlayComSetting" : type == 2 ? '/videoPlayComPartData' : type == 3 ? '/videoPlayComDetail' : ''


      // 用来 在详细数据的页面 横屏时  重置 html，body  css 样式
      sessionStorage.setItem("_rootSetting_reload_", true)

      this.$router.push({
        path,
        query: {
          no: this.no,
          channelNo: this.channelNo,
          ysNo: this.ysNo
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../codeFunCommon.scss";
.video_wrap {
  background: #ffffff;
  .video {
    width: 100%;
    height: 220px;
    background: #999;
  }

  .body {
    padding: 12px 10px;
  }

  .contrl {
    display: flex;
    margin-bottom: 22px;
    padding: 12px;
    width: 100%;
    box-sizing: border-box;

    .left {
      position: relative;
      flex: 1;
      width: 50%;

      .circular {
        border-radius: 50%;
      }

      .circular1 {
        position: relative;
        width: 183.54px;
        height: 183.54px;
        background: rgba(241, 246, 251, 1);
        box-shadow: 2px 2px 8px 0px rgba(37, 87, 210, 0.15);
        text-align: center;
      }

      .circular2 {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 144px;
        height: 144px;
        background: linear-gradient(
            129.67deg,
            rgba(122, 127, 133, 0.4) 0%,
            rgba(255, 255, 255, 0.4) 100%
          ),
          linear-gradient(
            133.76deg,
            rgba(230, 231, 237, 1) 0%,
            rgba(247, 248, 250, 1) 100%
          );
        background-blend-mode: soft-light;
        box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
          -2px -3px 8px 0px rgba(250, 250, 252, 1),
          1px 1px 5px 0px rgba(177, 181, 198, 1);
      }

      .circular3 {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 20.17px;
        height: 20.17px;
        background: rgba(37, 87, 210, 1);
      }

      .horn {
        position: absolute;
        user-select: none;

        i {
          color: rgba(206, 213, 220, 1);
          font-size: 22px;
        }
      }

      .horn-top {
        top: 0px;
        left: 60px;
        transform: rotateX(145deg);
      }

      .horn-right {
        top: 52px;
        right: 6px;
        transform: rotate(-90deg);
      }

      .horn-bottom {
        bottom: 0px;
        left: 63px;
      }

      .horn-left {
        top: 52px;
        left: 6px;
        transform: rotate(90deg);
      }
    }

    .right {
      flex: 1;
      padding: 16px 10px 0 30px;
      font-size: 14px;
      width: 50%;
      box-sizing: border-box;

      .box {
        text-align: center;
        width: auto !important;

        .label {
          margin-top: 8px;
        }

        i {
          color: rgba(46, 95, 215, 1);
        }
      }

      .r_top,
      .r_bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // width: 50%;
        box-sizing: border-box;

        .r_block {
          position: relative;
          display: inline-block;
          width: 44.13px;
          height: 44.13px;
          line-height: 44.13px;
          text-align: center;
          background: linear-gradient(
              129.67deg,
              rgba(122, 127, 133, 0.4) 0%,
              rgba(255, 255, 255, 0.4) 100%
            ),
            linear-gradient(
              133.76deg,
              rgba(230, 231, 237, 1) 0%,
              rgba(247, 248, 250, 1) 100%
            );
          background-blend-mode: soft-light;
          box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
            -2px -3px 4px 0px rgba(250, 250, 252, 1),
            1px 1px 2px 0px rgba(177, 181, 198, 1);
          border-radius: 10px;
        }

        .miaozhun {
          position: absolute;
          top: 1px;
          left: 2px;
          right: 0;
          bottom: 0;
          margin: 0;
          font-size: 20px;
        }

        img {
          width: 60%;
          height: 60%;
        }
      }

      .r_top {
        margin-bottom: 20px;
      }
    }
  }

  .calendar {
    display: flex;
    margin-bottom: 12px;
    font-size: 14px;

    .left {
      display: flex;

      .date-item {
        width: 39.78px;
        height: 40.66px;
        margin-right: 6px;
        background: rgba(210, 234, 253, 1);
        border-radius: 10px;
        text-align: center;
      }

      .active {
        background: rgba(37, 87, 210, 1);
        color: #ffffff;

        &::after {
          display: table;
          content: " ";
          width: 6px;
          height: 6px;
          background: rgba(37, 87, 210, 1);
          border-radius: 50%;
          margin-left: 16px;
          margin-top: 5px;
        }
      }
    }

    .right {
      position: relative;
      font-size: 18px;

      .icon-rili {
        font-size: 34px !important;
      }

      span {
        position: absolute;
        top: 12px;
        left: 7px;
      }
    }
  }

  .img-group {
    // padding: 0 10px 10px;

    .date {
      line-height: 40px;
      text-align: left;
    }

    .time {
      font-size: 12px;
      text-align: left;
    }

    .pic {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      width: 100%;

      .pic_item {
        width: 33%;
        // height: 100px;
        margin-bottom: 0.3rem;
        overflow: hidden;
        margin-right: 11px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.position {
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-size: 16px;
    }

    ::v-deep button {
      background: #1989fa;
      border-radius: 6px;
      height: 34px;
    }
  }
}

.nums {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;

  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 22%;
    color: #464646;
    margin-bottom: 10px;
    background: #f7f7f7;
    border: 0.95px solid #eceef2;
    border-radius: 4px;
    padding: 8px 0;
  }

  .active {
    background: #3a6ae0;
    color: #ffffff;
  }

  .noUse {
    color: #cdc4c4;
  }
}

.point_popup {
  .title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 18px;
  }

  img {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 18px;
    top: 23px;
  }

  .btns {
    text-align: center;
    margin-top: 40px;
    .save {
      width: 80%;
      height: 48px;
      line-height: 48px;
      background: #3a6ae0;
      border-radius: 29.5px;
      margin: auto;
      color: #ffffff;
    }
  }
}

.btn-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;

  button {
    width: 23%;
    height: 35px;
    line-height: 35px;
    padding-left: 0;
    padding-right: 0;
    background-color: #4778e7;
    border-color: #4778e7;
    border-radius: 6px;
  }
}

.data-page {
  background-color: #f7f7f7;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  .section {
    margin: 20px 0;
    padding: 10px 10px 12px 16px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 10.5px 31px #3981f60d;
    .space-x-13 {
      & > *:not(:first-child) {
        margin-left: 13px;
      }
      .image {
        width: 21px;
        height: 21px;
      }
      .text {
        color: #333333;
        font-size: 16px;
        font-family: PingFang SC;
        line-height: 14.5px;
      }
    }
    .text_2 {
      color: #808d9e;
      font-size: 12px;
      font-family: PingFang SC;
      line-height: 11px;
    }
    .section_2 {
      padding: 14px 8px;
      background-color: #f8f8f8;
      .text-wrapper {
        width: 58px;
      }
      .font_2 {
        font-size: 14px;
        font-family: PingFang SC;
        line-height: 13px;
        color: #505e82;
      }
    }
    .group {
      padding: 14px 16px 0;
      .text-wrapper_2 {
        width: 64.5px;
        border-right: solid 1px #e8e8e8;
      }
      .font_3 {
        font-size: 14px;
        font-family: PingFang SC;
        line-height: 10.5px;
        font-weight: 700;
        color: #333333;
      }
      .section_3 {
        background-color: #e8e8e8;
        width: 1px;
        height: 15.5px;
      }
      .text_6 {
        margin-right: 8px;
      }
    }
  }
  .space-y-10 {
    & > *:not(:first-child) {
      margin-top: 10px;
    }
  }
}
</style>
